import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_APPOINTMENT_DETAIL,
    getAppointmentDetailFail,
    getAppointmentDetailSuccess
} from '../action/getAppointmentDetailAction'

// api 
import getAppointmentDetailApi from '../api/getAppointmentDetailApi'

export function* getAppointmentDetailSaga(action) {
    try {
        const response = yield call(() => getAppointmentDetailApi(action.params))
        if (response.data.status === 1) {
            yield put(getAppointmentDetailSuccess(response, action))
        } else {
            yield put(getAppointmentDetailFail(response, action))
        }
    }
    catch (e) {
        yield put(getAppointmentDetailFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_APPOINTMENT_DETAIL, getAppointmentDetailSaga)
}